import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-symbol-rules",
  templateUrl: "./symbol-rules.component.html",
  styleUrls: ["./symbol-rules.component.scss"],
})
export class SymbolRulesComponent {
  @Input() showDialog = false;
  @Output() dialogClosed = new EventEmitter<boolean>();

  closeDialog() {
    this.showDialog = false;
    this.dialogClosed.emit(true);
  }
}
